import React, { useContext } from 'react';
import { AppContext } from '../contexts/AppContext';
import {translate} from '../helpers/base';
const SortOverlay = () => {

    const { setIsSortOverlayVisible, selectedFilters, handleSortChange, hasResultsWithPrices } = useContext(AppContext);
    const sortBy = selectedFilters.sort ?? '';
    const handleClose = () => {
        setIsSortOverlayVisible(false);
    };
    const handleChange = (event) => {
        handleSortChange(event.target.value);
        setIsSortOverlayVisible(false);
    };

    let options = {
        'rating-desc': translate('accommodation-overview.results.sort.ratingDesc'),
    };

    if(hasResultsWithPrices) {
        options = {
            ...options,
            'price-asc': translate('accommodation-overview.results.sort.priceAsc'),
            'price-desc': translate('accommodation-overview.results.sort.priceDesc'),
        }
    }

    if (selectedFilters.lat && selectedFilters.lng) {
        options = {
            ...options,
            'distance': translate('accommodation-overview.results.sort.distance'),
        };
    }

    options = {
        ...options,
        'award-desc': translate('accommodation-overview.results.sort.awardAsc'),
        'award-asc': translate('accommodation-overview.results.sort.awardDesc'),
    };

    return (
        <div className="accommodation-overview-sort--inner">
            <div className="area--text">
                <p className="lead">{translate('accommodation-overview.results.sort.header')}</p>
                <label className="overlay-close" onClick={handleClose} />
            </div>
            <ul>
                {Object.entries(options).map(([value, label]) => (
                    <li key={value}>
                        <input
                            type="radio"
                            id={`option-${value}`}
                            value={value}
                            checked={sortBy === value}
                            onChange={handleChange}
                        />
                        <label htmlFor={`option-${value}`} className="btn btn-outline btn-sm btn-block">
                            {label}
                        </label>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default SortOverlay;
